import CheckoutForm from './stripe';
export default CheckoutForm;



//////////////////
// WEBPACK FOOTER
// ./src/components/stripe/index.ts
// module id = 1363
// module chunks = 0 1 2 3 5